// extracted by mini-css-extract-plugin
module.exports = {"clear":"Screen_clear__sTdXk","blurred":"Screen_blurred__VvyfN"};